<template>
	<div class="draft_content">

	<v-layout>
        <v-flex class="search-bar">
          <v-text-field grey-text-input flat solo hide-details  placeholder="Search" v-model="searchText">
          	<!-- <v-btn slot="append-outer" flat style="margin:0" @click="functions.openDialog('filter_dialog')">{{filterValue ? filterValue : 'ALL'}} <v-icon left>arrow_drop_down</v-icon></v-btn> -->
          </v-text-field>
        </v-flex>
    </v-layout>

    <v-divider></v-divider>

	<v-list three-line v-if="draftItems.length && !loading" nopadding>
      <div v-for="(item, index) in draftItems" :key="index">
      	<v-list-tile>
           	<v-list-tile-content @click="functions.openDraft(item.formPath, item)">
              <v-list-tile-title>
              	{{item.title ? item.title : '-'}}
              </v-list-tile-title>
              <v-list-tile-sub-title>{{item.formName}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.modifiedDate | moment("from", "now")}}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
            	<v-menu bottom left>
				    <v-btn slot="activator" icon>
				      	<v-icon>more_vert</v-icon>
				    </v-btn>

				    <v-list nopadding>
				        <v-list-tile @click="functions.openDraft(item.formPath, item)">
				          <v-list-tile-title>Open</v-list-tile-title>
				        </v-list-tile>

				        <v-divider></v-divider>

				        <v-list-tile @click="functions.discardDraft(item.draftId, index)">
				          <v-list-tile-title>Discard</v-list-tile-title>
				        </v-list-tile>
				    </v-list>

			    </v-menu>
            </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="draftItems.length-1 != index"></v-divider>
      </div>

    </v-list>

    <div v-if="!draftItems.length && !loading" center-align padding-all-16 color-light-grey>There are no drafts</div>

</div>
</template>

<script>
// import TextHighlight from 'vue-text-highlight';

	export default{
		props:['draftItems', 'functions', 'filterValue', 'loading'],
		// components:{
		// 	'text-highlight':TextHighlight
		// },
		data(){
			return{
				searchText:'',
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/actions/draft/draft_transaction.vue